
const PracticePushLog = resolve =>require(['@/page/PracticePushLog.vue'], resolve)

export default {
	path: '/home/practicePushLog',
	component: PracticePushLog,
	meta:{
		title: '练习库',
		path:'/home/practice'
	}
}



// WEBPACK FOOTER //
// ./src/router/PracticePushLog.js